var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e0b644ed3ff2eb0df64ce9fed4c7fb46f234748e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kenziecom@kenzie-br"]={id:"e0b644ed3ff2eb0df64ce9fed4c7fb46f234748e"};
      